module.exports = __webpack_public_path__ + "./assets/img_jiaoxi_color@2x__cac8a703b4ab46a14c642b7a6a05be99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_jiaoxi_color@2x.jpg
// module id = 631
// module chunks = 12